import { createConsumer } from '@rails/actioncable';

const URL = process.env.REACT_APP_PAYPAIR_ENV === 'production' ? 'wss://api.paypair.com/cable' : 'wss://sandbox.paypair.com/cable';
const consumer = createConsumer(URL);

export default consumer;
